export const MAX_WITHDRAWAL_AMOUNT = 6200
export const MAX_PAYMENT_AMOUNT = 10_000_000
